// Base
import DIApi from './_diApi';
// Class
class DefaultAccountAPI extends DIApi {
  controllerName = 'DefaultAccounts';
}

export default new DefaultAccountAPI();
